module.exports = __webpack_public_path__ + "static/img/ended.7ad6337.svg";


//////////////////
// WEBPACK FOOTER
// ./static/image/activityManage/ended.svg
// module id = DS0M
// module chunks = 1